/* eslint-disable no-restricted-globals */
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useHeader } from "data/context/header-context";
import { getEnv } from "helper/window-helper";
import { clearAuthLocalStorage } from "helper/logout-helper";
import { isValidJwtFormat } from "helper/jwt-token-helper";
import { setLocalStorege } from "data/cache/localstorage-cache";
import { AuthUseCase } from "service/api/rest/auth-usecase";
import TokenAuthenticationPage from "pages/layout/auth/token-authentication-page";
import { UseAuth } from "hook/auth-hook";

function resolveAuthBody(body: unknown): { token: string } | null {
    if (!body || typeof body !== "object") {
        return null;
    }

    const token = (body as { token?: unknown }).token;
    if (!isValidJwtFormat(token)) {
        return null;
    }

    return { token };
}

export const TokenAuthenticationFactory: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { updateIsLoggedIn } = UseAuth();
    const { hideHeader, showHeader } = useHeader();

    useEffect(() => {
        hideHeader();
        return () => {
            showHeader();
        };
    }, [hideHeader, showHeader]);

    const ENDPOINT_LOGIN = getEnv("REACT_APP_END_POINT_LOGIN")!;
    const LOCALSTORAGE_TOKEN_USER_LOGIN = getEnv("REACT_APP_LOCALSTORAGE_TOKEN_USER_LOGIN")!;
    const LOCALSTORAGE_VIEW_COMMUNIQUE = getEnv("REACT_APP_LOCALSTORAGE_VIEW_COMMUNIQUE")!;
    const TOKEN_EXCHANGE_CLIENT_ID = getEnv("REACT_APP_TOKEN_EXCHANGE_CLIENT_ID") ?? "is-compras";

    useEffect(() => {
        const authenticateByToken = async () => {
            const accessToken = searchParams.get("access_token");

            if (!accessToken) {
                navigate("/error-token", { replace: true });
                return;
            }

            clearAuthLocalStorage();
            updateIsLoggedIn(false);

            try {
                const response = await new AuthUseCase(
                    `${ENDPOINT_LOGIN}/token-exchange`
                ).Post({
                    data: {
                        subject_token: accessToken,
                        access_token: accessToken,
                        client_id: TOKEN_EXCHANGE_CLIENT_ID
                    }
                });

                if (response.statusCode === 200) {
                    const authBody = resolveAuthBody(response.body);

                    if (!authBody) {
                        navigate("/error-token", { replace: true });
                        return;
                    }

                    setLocalStorege(LOCALSTORAGE_TOKEN_USER_LOGIN, authBody);
                    setLocalStorege(LOCALSTORAGE_VIEW_COMMUNIQUE, { view: true });
                    location.replace("/");
                    return;
                }
            } catch (error) {

            }

            navigate("/error-token", { replace: true });
        };

        authenticateByToken();
    }, [ENDPOINT_LOGIN, LOCALSTORAGE_TOKEN_USER_LOGIN, LOCALSTORAGE_VIEW_COMMUNIQUE, TOKEN_EXCHANGE_CLIENT_ID, navigate, searchParams, updateIsLoggedIn]);

    return <TokenAuthenticationPage />;
};
